module.exports = __webpack_public_path__ + "static/web-3-ffbd74bb1a6457bda058fe735d3d2e79.mp4";